const _ = require('lodash');

/**
 * Get the plugin image thumb url from object
 * @returns {string}
 */
export function getPluginThumbUrlFromObject(plugin) {
  return _.get(plugin, 'pluginData.0.images.thumb.url', process.env.VUE_APP_PLUGIN_PLACEHOLDER_IMAGE_URL);
}
